// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__f--4h","resendInfoText":"OnGoingPaymentBox_resendInfoText__1bdwn"};